import React from 'react';

export interface BenefitsItemProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
	title: string;
	index?: number;
}

const BenefitsItem: React.FC<BenefitsItemProps> = ({ title, index, href, children, ...props }) => {
	return (
		<li className="benefits-list-item">
			{index !== undefined && <div className="benefits-list-index">{index + 1}</div>}
			<h3 className="benefits-list-title">{title}</h3>
			<div className="benefits-list-text">
				{children}
				&nbsp;
				{href && (
					<a href={href} target="_blank" className="benefits-list-more" {...props}>
						Learn more
					</a>
				)}
			</div>
		</li>
	);
};

export default BenefitsItem;
